import { Repo, RepoFile, repoOptions } from "./data";
import { clearEditor, EditorResult, startEditor } from "./editor";
import {
	chooseOption,
	clearTerminal,
	readLine,
	removeTerminalCursor,
	separatorLine,
	writeLines,
} from "./terminal";

const getRoundLine = (round: number, wantsToPlayAgain: boolean) => {
	if (round === 1) return "Welcome to coding fingers!\n A place to improve your typing speed by using actual code snippets rather than random English paragraphs\n You may code your way to speedier fingertips here Languages such as C, Python, and React which are available\n for now (You can also request ur fav language) Your typing speed and accuracy are recorded. So you may brag\n about your performance to other people. So, what are you looking forward to? Begin coding now to increase your\n typing speed!\n\n"
	if (wantsToPlayAgain) return "Yay! Let's play again! :)";
	return "Ah whatever, I'm just gonna let you play again! :)";
};

clearTerminal();



const writeFileHeader = async (repo: Repo, file: RepoFile) => {
	clearTerminal();
	const lines = [
		`${repo.label} it is!`,
		separatorLine,
		`Repo: ${repo.url}`,
		`File: ${file.path}`,
		" ",
		"When you are ready, start typing!",
		separatorLine,
		" ",
	];
	await writeLines(lines);
};

const writeResult = async (result: EditorResult) => {
	const errors = result.totalCharacters - result.correctCharacters;
	const accuracy =
		result.totalCharacters > 0
			? (result.correctCharacters / result.totalCharacters) * 100
			: 0;
	const ccps = (result.correctCharacters / result.totalTime) * 1000 * 60;

	const lines = [
		result.reachedTheEnd
			? "Wow you've completed the entire snippet!"
			: "Time's up!",
		"Here are your results:",
		separatorLine,
		" ",
		`Correct characters per minute: ${ccps.toFixed(2)}`,
		`Total errors: ${errors > 0 ? errors : "No errors, what a performance!"}`,
		`Accuracy: ${accuracy.toFixed(2)}%`,
		" ",
		separatorLine,
		"Wanna play again? (y, n)",
		" ",
	];
	await writeLines(lines);
};

const runGame = async () => {
	let round = 1;
	let wantsToPlayAgain = true;

	while (true) {
		clearTerminal();
		await writeLines([
			getRoundLine(round, wantsToPlayAgain),
			"Please select practice repo:",
			" ",
		]);
		const repo = await chooseOption(repoOptions);
		const file = repo.files[Math.floor(Math.random() * repo.files.length)];
		await writeFileHeader(repo, file);
		removeTerminalCursor();

		const result = await startEditor(file.code);

		clearEditor();
		clearTerminal();
		await writeResult(result);

		wantsToPlayAgain = (await readLine()) === "y";
		round++;
	}
};

runGame();
function bold() {
	throw new Error("Function not implemented.");
}

